import React from 'react';
import { EventItem } from '../../types/event';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faClock, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import '../../styles/EventDetailCard.css';

interface EventDetailCardProps {
  event: EventItem;
}

const EventDetailCard: React.FC<EventDetailCardProps> = ({ event }) => {
  // Format the date for display
  const formatEventDate = (dateString: string): string => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Format the time for display
  const formatEventTime = (event: EventItem): string => {
    return `${event.startTime.doorsOpen} - ${event.endTime || 'TBD'}`;
  };

  return (
    <div className="event-detail-card">
      <div className="event-detail-image">
        <img src={event.imageUrl || '/images/room_events.jpg'} alt={event.title} />
      </div>
      <div className="event-detail-content">
        <h2>{event.title}</h2>
        
        <div className="event-detail-metadata">
          <div className="metadata-item">
            <FontAwesomeIcon icon={faCalendarAlt} />
            <span>{formatEventDate(event.date)}</span>
          </div>
          <div className="metadata-item">
            <FontAwesomeIcon icon={faClock} />
            <span>{formatEventTime(event)}</span>
          </div>
          <div className="metadata-item">
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            <span>{event.address}</span>
          </div>
        </div>
        
        <div className="event-detail-description">
          {event.description}
        </div>
      </div>
    </div>
  );
};

export default EventDetailCard;
